import { Helmet } from 'react-helmet';
import ThamsoDetail
  from 'src/components/thamso-detail/ThamsoDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

import ThamsoListToolbar from '../components/thamso-detail/ThamsoToolbar';

const Thamso = () => (
  <>
    <Helmet>
      <title>Tham số</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        {/* <ThamsoListToolbar /> */}
        <Box sx={{ pt: 3 }}>
          <ThamsoDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default Thamso;
